import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import ProductVisual from "./ProductVisual";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <main className="shop">
      <div className="shop-controls">
        <div>
          <p className="shop-kicker">EVERYDAY SERIES 01</p>
          <h1>SHOP ALL</h1>
          <p className="shop-intro"><strong>{productData.length} products.</strong> Preview catalogue with AI-generated product representations. Production photography, stock and checkout are pending verification.</p>
        </div>
      </div>
      <div className="products-grid">
        {productData.map((product) => (
          <Link
            to={`/shopDetails/${product.id}`}
            key={product.id}
            className="product-card"
            onClick={toTop}
          >
            <div className="product-image-wrapper">
              <ProductVisual product={product} />
            </div>
            <div className="product-info">
              <h3 className="product-name">{product.name}</h3>
              <div className="product-price">${product.price}</div>
            </div>
          </Link>
        ))}
      </div>
    </main>
  );
}

export default Shop;
